import { RISK_LEVEL_LABELS } from "../constants/environmentalRiskLayers.js";

export function formatRiskLevel(level) {
  return RISK_LEVEL_LABELS[level] || RISK_LEVEL_LABELS.unavailable;
}

export function formatRiskScore(score) {
  if (score == null || !Number.isFinite(score)) {
    return "—";
  }

  return `${Math.round(score)} / 100`;
}

export function formatEnvironmentalHealthLabel(score, riskLevel) {
  if (riskLevel && riskLevel !== "unavailable") {
    return formatRiskLevel(riskLevel);
  }

  if (score == null || !Number.isFinite(score)) {
    return "Unavailable";
  }

  if (score <= 25) {
    return "Good";
  }

  if (score <= 45) {
    return "Fair";
  }

  if (score <= 65) {
    return "Elevated";
  }

  return "Constrained";
}

export function formatFactorList(factors = [], limit = 3) {
  return (factors || [])
    .slice(0, limit)
    .map((factor) => factor.explanation)
    .filter(Boolean);
}
